import React from 'react';
import { Box, Typography, Paper, Stack, Grid, Container, useMediaQuery, useTheme } from '@mui/material';

type Feature = {
  title: string;
  description: string;
};

const features: Feature[] = [
  {
    title: 'Discover',
    description: 'Explore a diverse AI agents tailored for a wide range of domain/ Industry and tasks. Our recommendation chat engine suggest the most relevant agents for your problem statement.',
  },
  {
    title: 'Always-On',
    description: 'Benefit from AI agents that work around the clock, delivering uninterrupted service, rapid response times, and seamless operations ensuring your business never misses a beat',
  },
  {
    title: 'Accelerate',
    description: 'AI agents handle repetitive and time-consuming tasks, freeing up human resources for strategic work. Empower your team to prioritize strategic initiatives and unlocking greater efficiency, and accelerating growth.',
  },
];

const WhyAgent = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <>
      <Box sx={{ py: isMobile ? 3 : 8, backgroundColor: '#fff' }}>
        <Container maxWidth="lg">
          <Typography variant="h4" fontWeight={700} textAlign="center" sx={{ mb: 1 }}>
            Discover the Power of AI Agents in Our Marketplace
          </Typography>
          <Box
            sx={{
              width: 60,
              height: 4,
              backgroundColor: '#1976d2',
              borderRadius: 2,
              mx: 'auto',
              mb: 5,
            }}
          />
          <Box>
            <Grid container spacing={4} justifyContent="center">
              {features.map((feature, index) => (
                <Grid key={index}>
                  <Paper
                    elevation={2}
                    sx={{
                      textAlign: 'center',
                      p: 3,
                      borderRadius: '1rem',
                      boxShadow: 3,
                      backgroundColor: '#f8f9fa',
                      maxWidth: '210px',
                      minHeight: '230px',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-5px)',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)',
                      },
                    }}
                  >
                    <Stack spacing={2} alignContent="center" alignItems="center">
                      
                      <Typography variant="h6" component="h3" sx={{ fontWeight: 600, mb: 1 }}>
                        {feature.title}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {feature.description}
                      </Typography>
                    </Stack>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default WhyAgent;
